<template>
  <d2-container>
    <template slot="header">
      <div class="app-container calendar-list-container">
        <div class="filter-container">
          <el-input size="small" @keyup.enter.native="handleFilter" style="width: 200px; margin-right: 10px"
            class="filter-item" placeholder="搜索" clearable="" v-model="listQuery.keyWord">
          </el-input>

          <el-date-picker @change="changeMediateStartDate" @keyup.enter.native="searchDate()" size="small"
            style="margin-left: 10px" v-model="startValue" type="daterange" range-separator="至"
            value-format="yyyy-MM-dd" start-placeholder="收案开始日期" end-placeholder="收案结束日期">
          </el-date-picker>
          <el-date-picker @change="changeMediateEndDate" @keyup.enter.native="search()" size="small"
            style="margin-left: 10px" v-model="endValue" type="daterange" range-separator="至" value-format="yyyy-MM-dd"
            start-placeholder="结案开始日期" end-placeholder="结案结束日期">
          </el-date-picker>
          <el-button style="margin-left: 10px" size="small" class="filter-item" type="primary" icon="search"
            @click="handleFilter">搜索</el-button>
          <el-button style="margin-left: 10px" size="small" class="filter-item" type="danger" icon="search"
            @click="reset">重置</el-button>
          <div style="margin: 10px 0 0 0">
            <el-dropdown @command="exPortHandleCommand">
              <el-button type="primary" size="small">
                导出 <i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu>
                <el-dropdown-item command="exportDayExcel">导出月度案件汇总</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      </div>
    </template>

    <el-table :key="tableKey" :data="list" v-loading.body="listLoading" size="small" stripe border height="560"
      highlight-current-row style="width: 100%" @selection-change="handleSelectionChange">
      <el-table-column width="100px" align="center" label="系統编号">
        <template slot-scope="scope">
          <span>{{ scope.row.id }}</span>
        </template>
      </el-table-column>
      <el-table-column width="150px" align="center" label="案号">
        <template slot-scope="scope">
          <span>{{ scope.row.caseCode }}</span>
        </template>
      </el-table-column>
      <el-table-column width="70px" align="center" label="重要案件">
        <template slot-scope="scope">
          <el-button type="primary" size="small" v-if="scope.row.isMajor == '是'">{{ scope.row.isMajor }}</el-button>
          <span v-else>
            {{ scope.row.isMajor }}
          </span>
        </template>
      </el-table-column>
      <el-table-column width="100px" align="center" label="案由">
        <template slot-scope="scope">
          <span>{{ scope.row.caseType }}</span>
        </template>
      </el-table-column>
      <el-table-column width="100px" align="center" label="法院">
        <template slot-scope="scope">
          <span>{{ scope.row.court }}</span>
        </template>
      </el-table-column>
      <el-table-column width="150px" align="center" label="原告">
        <template slot-scope="scope">
          <span>{{ scope.row.plaintiff }}</span>
        </template>
      </el-table-column>
      <el-table-column width="100px" align="center" label="被告">
        <template slot-scope="scope">
          <span>{{ scope.row.defendant }}</span>
        </template>
      </el-table-column>
      <el-table-column width="100px" align="center" label="标的">
        <template slot-scope="scope">
          <span>{{ scope.row.biaodi }}</span>
        </template>
      </el-table-column>
      <el-table-column width="100px" align="center" label="调解员">
        <template slot-scope="scope">
          <span>

            {{ scope.row.userName }}
          </span>
        </template>
      </el-table-column>
      <el-table-column width="100px" align="center" label="收案时间">
        <template slot-scope="scope">
          <span>{{ scope.row.mediateStartDate }}</span>
        </template>
      </el-table-column>
      <el-table-column width="100px" align="center" label="结案时间">
        <template slot-scope="scope">
          <span>{{ scope.row.mediateEndDate }}</span>
        </template>
      </el-table-column>
      <el-table-column width="100px" align="center" label="案件状态">
        <template slot-scope="scope">
          <span v-if="scope.row.status === 0" style="color: orange">未分配</span>
          <span v-if="scope.row.status === 1" style="color: blue">调解中</span>
          <span v-if="scope.row.status === 2" style="color: green">调解成功</span>
          <span v-if="scope.row.status === 3" style="color: red">调解失败</span>
          <span v-if="scope.row.status === 4" style="color: skyblue">撤诉</span>
          <span v-if="scope.row.status === 5" style="color: purple">仅签订送达地址确认书</span>
        </template>
      </el-table-column>
      <el-table-column width="150px" align="center" label="创建时间">
        <template slot-scope="scope">
          <span>{{ scope.row.createTime }}</span>
        </template>
      </el-table-column>


      <el-table-column align="center" label="操作" width="150">
        <template slot-scope="scope">

          <el-button v-permission:function="['caseRecordsManager_btn_del']" size="small" type="danger"
            @click="handleDelete(scope.row)">删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <template slot="footer">
      <div v-show="!listLoading" class="pagination-container">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page.sync="listQuery.pageNum" :page-sizes="[20, 50, 200, 500]" :page-size="listQuery.page"
          layout="total, sizes, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>
    </template>
    <el-dialog :title="textMap[dialogStatus]" :visible.sync="dialogFormVisible">
      <el-form :model="form" :rules="rules" ref="form" label-width="100px">
        <el-form-item label="案号" prop="caseCode">
          <el-input v-model="form.caseCode" placeholder="请输入案号"></el-input>
        </el-form-item>
        <el-form-item label="案由" prop="caseType">
          <el-input v-model="form.caseType" placeholder="请输入案由"></el-input>
        </el-form-item>
        <el-form-item label="原告" prop="plaintiff">
          <el-input v-model="form.plaintiff" placeholder="请输入原告"></el-input>
        </el-form-item>
        <el-form-item label="被告" prop="defendant">
          <el-input v-model="form.defendant" placeholder="请输入被告"></el-input>
        </el-form-item>
        <el-form-item label="案件状态" prop="status">
          <el-input v-model="form.status" placeholder="案件状态："></el-input>
        </el-form-item>
        <el-form-item label="调解失败原因" prop="mediateFailReason">
          <el-input v-model="form.mediateFailReason" placeholder="请输入调解失败原因"></el-input>
        </el-form-item>

        <el-form-item label="用户ID" prop="userId">
          <el-input v-model="form.userId" placeholder="请输入用户ID"></el-input>
        </el-form-item>
        <el-form-item label="创建时间" prop="createTime">
          <el-input v-model="form.createTime" placeholder="请输入创建时间"></el-input>
        </el-form-item>
        <el-form-item label="调解开始日期" prop="mediateStartDate">
          <el-input v-model="form.mediateStartDate" placeholder="请输入调解开始日期"></el-input>
        </el-form-item>
        <el-form-item label="调解结束日期" prop="mediateEndDate">
          <el-input v-model="form.mediateEndDate" placeholder="请输入调解结束日期"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel('form')" size="small">取 消</el-button>
        <el-button v-if="dialogStatus == 'create'" size="small" type="primary" @click="create('form')">确 定</el-button>
        <el-button v-else type="primary" size="small" @click="update('form')">确 定</el-button>
      </div>
    </el-dialog>



    <el-dialog title="提示" :visible.sync="dateDialog" width="30%" center>
      <div>
        <div style="display: flex; padding: 0px" class="jfsj">
          <span align="right" style="display: inline-block; width: 100px; line-height: 40px">调解成功时间</span>

          <el-date-picker @change="changeMediateTime" @keyup.enter.native="search()"
            style="width: 70%; margin-left: 10px" v-model="value2" value-format="yyyy-MM-dd" type="daterange"
            range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
          </el-date-picker>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dateDialog = false">取 消</el-button>
        <el-button type="primary" @click="downLoad">确 定</el-button>
      </span>
    </el-dialog>




    <el-dialog :title="textMap[dialogStatus]" :visible.sync="dialogAssignment">
      <h1>分案</h1>
      <el-select v-model="userId" filterable placeholder="请选择">
        <el-option v-for="item in userSection" :key="item.value" :label="item.label" :value="item.value">
        </el-option>
      </el-select>
      <br />
      <el-button type="primary" size="small" @click="assignment" style="margin-top: 30px">确 定</el-button>
    </el-dialog>
  </d2-container>
</template>
<style>
.my-autocomplete li {
  line-height: normal;
  padding: 7px;
}

.my-autocomplete .name {
  text-overflow: ellipsis;
  overflow: hidden;
}

.my-autocomplete .addr {
  font-size: 12px;
  color: #b4b4b4;
}

.my-autocomplete .highlighted .addr {
  color: #ddd;
}

.demo-table-expand {
  font-size: 0;
}

.demo-table-expand label {
  width: 150px;
  color: #99a9bf;
}

.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 40%;
}

.demo-table-expand {
  font-size: 0;
}

.demo-table-expand label {
  width: auto;
  color: #99a9bf;
}

.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}

.el-popover__reference {
  padding: 2px;
  font-size: 8px;
}
</style>
<script>
import {
  page,
  addObj,
  getObj,
  delObj,
  putObj,
  getAllUser,
  assignmentCase,
  exportDayExcel
} from "@/api/caseMediate/index";
import { mapGetters } from "vuex";
import util from "@/libs/util";
import axios from "axios";
export default {
  name: "caseRecords",
  data() {
    return {
      value2: [],
      isDownload: false,
      form: {
        caseCode: undefined,
        caseType: undefined,
        plaintiff: undefined,
        defendant: undefined,
        status: undefined,
        mediateFailReason: undefined,
        userId: undefined,
        createTime: undefined,
        mediateStartDate: undefined,
        mediateEndDate: undefined,
      },
      multipleSelection: [],
      rules: {
        caseCode: [
          {
            required: true,
            message: "请输入案号",
            trigger: "blur",
          },
        ],
        caseType: [
          {
            required: true,
            message: "请输入案由",
            trigger: "blur",
          },
        ],
        plaintiff: [
          {
            required: true,
            message: "请输入原告",
            trigger: "blur",
          },
        ],
        defendant: [
          {
            required: true,
            message: "请输入被告",
            trigger: "blur",
          },
        ],
        status: [
          {
            required: true,
            message: "请输入案件状态：1调解中，2调解成功，3调解失败",
            trigger: "blur",
          },
        ],
        userId: [
          {
            required: true,
            message: "请输入用户ID",
            trigger: "blur",
          },
        ],
      },
      list: null,
      total: null,
      listLoading: true,
      listQuery: {
        pageNum: 1,
        page: 50,
        keyWord: undefined,
        status: undefined,
        userId: undefined,
        sort: "desc",
      },
      userId: undefined,
      userSection: [],
      dialogFormVisible: false,
      dialogAssignment: false,
      dialogStatus: "",
      textMap: {
        update: "编辑",
        create: "创建",
      },
      tableKey: 0,
      startValue: "",
      endValue: "",
      dateDialog: false
    };
  },
  created() {
    this.getList();
    this.getUser();
  },
  computed: {
    ...mapGetters(["elements"]),
  },
  methods: {
    changeMediateTime(e) {
      if (e == "" || e == null || e == undefined) {
        this.value2 = "";
      }
    },
    downLoad() {
      let data
      if (
        this.value2 != undefined &&
        this.value2 != "" &&
        this.value2 != null &&
        this.value2.length > 0
      ) {
        data = {
          mediateEndDateS: this.value2[0],
          mediateEndDateE: this.value2[1]
        }
      }
      const token = util.cookies.get("token");
      this.dateDialog = false
      // this.listLoading = true
      let loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      axios({
        url:
          process.env.VUE_APP_API + "/api/case/caseRecords/expMonthlyExcel",
        method: "post",
        responseType: "arraybuffer",
        headers: {
          // 项目中请求头需要的信息（如果不需要可不写），如用户登录信息验证：
          authorization: "Bearer " + token,
        },
        data: data
        // dataType: 'json',
        // 项目中请求头需要的信息（如果不需要可不写），如用户登录信息验证：
      })
        .then((res) => {

          loading.close()
          // loading.close();
          this.value2 = []
          const disposition = res.headers["content-disposition"];
          const fileName = decodeURI(disposition);
          let url = window.URL.createObjectURL(
            new Blob([res.data], { type: ".zip" })
          );
          let a = document.createElement("a");
          a.style.display = "none";
          a.href = url;
          a.setAttribute("download", fileName);
          document.body.appendChild(a);
          a.click();
          url = window.URL.revokeObjectURL(url);
          document.body.removeChild(a);
        })
        .catch((res) => {
          loading.close();
        });
      return;
    },
    exPortHandleCommand(command) {
      if (command == "exportDayExcel") {
        this.dateDialog = true
      }
    },
    reset() {
      this.listQuery.keyWord = "";
      this.startValue = "";
      this.endValue = "";
      this.listQuery.mediateStartDateS = "";
      this.listQuery.mediateStartDateE = "";
      this.listQuery.mediateEndDateS = "";
      this.listQuery.mediateEndDateE = "";
      this.getList();
    },
    changeMediateStartDate(e) {
      if (e == "" || e == null || e == undefined) {
        this.startValue = "";
      }
    },
    changeMediateEndDate(e) {
      if (e == "" || e == null || e == undefined) {
        this.endValue = "";
      }
    },
    searchDate() {
      if (
        this.startValue != undefined &&
        this.startValue != "" &&
        this.startValue != null &&
        this.startValue.length > 0
      ) {
        this.listQuery.mediateStartDateS = this.startValue[0];
        this.listQuery.mediateStartDateE = this.startValue[1];
      } else {
        this.listQuery.mediateStartDateS = "";
        this.listQuery.mediateStartDateE = "";
      }
      if (
        this.endValue != undefined &&
        this.endValue != "" &&
        this.endValue != null &&
        this.endValue.length > 0
      ) {
        this.listQuery.mediateEndDateS = this.endValue[0];
        this.listQuery.mediateEndDateE = this.endValue[1];
      } else {
        this.listQuery.mediateEndDateE = "";
        this.listQuery.mediateEndDateS = "";
      }

      // this.listQuery.page = 1;
      // this.getList();
    },
    getList() {
      this.listLoading = true;
      page(this.listQuery).then((response) => {
        this.list = response.records;
        this.total = response.total;
        this.listLoading = false;
      });
    },
    handleFilter() {
      this.searchDate();
      this.getList();
    },
    handleSizeChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.pageNum = val;
      this.getList();
    },
    handleCommand(command) {
      this.listQuery.status = command;
    },
    handleCreate() {
      this.resetTemp();
      this.dialogStatus = "create";
      this.dialogFormVisible = true;
    },
    handleAssignment() {
      this.dialogStatus = "assignment";
      this.dialogAssignment = true;
    },
    getUser() {
    },
    downloadJasqs() {
      var caseList = this.multipleSelection;
      if (caseList.length < 1) {
        this.$message({
          message: "请选择案件",
          type: "warning",
        });
        return;
      }
      var ids = "";
      for (var i in caseList) {
        ids = ids.concat(caseList[i].id);

        if (i != caseList.length - 1) {
          ids = ids + ",";
        }
      }

      let params = { idList: ids, templateName: "结案书" };
      const token = util.cookies.get("token");

      axios({
        url: process.env.VUE_APP_API + "/api/case/caseRecords/downloadJasqs",
        method: "get",
        params: params,
        dataType: "json",
        responseType: "arraybuffer",
        headers: {
          // 项目中请求头需要的信息（如果不需要可不写），如用户登录信息验证：
          authorization: "Bearer " + token,
        },
      }).then((res) => {
        const contentDisposition = res.headers["content-disposition"];
        let fileName = window.decodeURI(contentDisposition);

        let url = window.URL.createObjectURL(
          new Blob([res.data], { type: ".zip" })
        );
        let a = document.createElement("a");
        a.style.display = "none";
        a.href = url;
        a.setAttribute("download", "结案书.zip");
        document.body.appendChild(a);
        a.click();
        url = window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
      });
    },

    assignment() {
      var caseList = this.multipleSelection;
      if (caseList.length < 1) {
        this.$message({
          message: "请选择案件",
          type: "warning",
        });
        return;
      }
      if (this.userId === null || this.userId === "") {
        this.$message({
          message: "请选择调解员",
          type: "warning",
        });
        return;
      }
      var userId = this.userId;
      var ids = "";
      for (var i in caseList) {
        ids = ids.concat(caseList[i].id);

        if (i != caseList.length - 1) {
          ids = ids + ",";
        }
      }
      let params = { idList: ids, userId: userId };
      assignmentCase(params).then((res) => {
        this.$message({
          message: "分配成功",
          type: "success",
        });
        this.getList();
        this.dialogAssignment = false;
      });
    },
    handleUpdate(row) {
      getObj(row.id).then((response) => {
        this.form = response;
        this.dialogFormVisible = true;
        this.dialogStatus = "update";
      });
    },
    handleDelete(row) {
      this.$confirm("此操作将永久删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        delObj(row.id).then(() => {
          this.$notify({
            title: "成功",
            message: "删除成功",
            type: "success",
            duration: 2000,
          });
          const index = this.list.indexOf(row);
          this.list.splice(index, 1);
        });
      });
    },
    create(formName) {
      const set = this.$refs;
      set[formName].validate((valid) => {
        if (valid) {
          addObj(this.form).then(() => {
            this.dialogFormVisible = false;
            this.getList();
            this.$notify({
              title: "成功",
              message: "创建成功",
              type: "success",
              duration: 2000,
            });
          });
        } else {
          return false;
        }
      });
    },
    cancel(formName) {
      this.dialogFormVisible = false;
      const set = this.$refs;
      set[formName].resetFields();
    },
    update(formName) {
      const set = this.$refs;
      set[formName].validate((valid) => {
        if (valid) {
          this.dialogFormVisible = false;
          this.form.password = undefined;
          putObj(this.form.id, this.form).then(() => {
            this.dialogFormVisible = false;
            this.getList();
            this.$notify({
              title: "成功",
              message: "创建成功",
              type: "success",
              duration: 2000,
            });
          });
        } else {
          return false;
        }
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    resetTemp() {
      this.form = {
        username: undefined,
        name: undefined,
        sex: "男",
        password: undefined,
        description: undefined,
      };
    },
  },
};
</script>
